let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kddSb")).then(() => parcelRequire('1qmxj'));